<template>
  <div>
    <v-breadcrumbs :items="breadcrumbItems"/>

    <v-card v-if="org">
      <v-container>
      <v-row>
        <v-col cols="12">
          <InsightsSummary ref="insights" />
        </v-col>
      </v-row>
      </v-container>
      <v-card-title class="headline">Insights for {{org.name}}</v-card-title>

      <v-card-text>      
        <p>
          Key metrics are calculated weekly, based on Monday - Sunday weeks. 
          Note that insights are always at least one day behind. 
        </p>
        <p>
          Insights are calculated based on standardized metrics, allowing a consistent measurement across events and comparison with industry standards (coming soon).
        </p>
      </v-card-text>

      <v-alert v-if="!orgUtil.isProPlan()" type="info" tile>
        <div class="d-flex flex-row align-content-center">
          <p class="grow mb-0"><router-link class="white--text" :to="{name: 'orgmanagerSubscription', params: {id:org.id}}">Upgrade to a PRO plan</router-link> to access insights.</p>
          <v-btn class="shrink white--text" :to="{name: 'orgmanagerSubscription', params: {id:org.id}}">Upgrade</v-btn>
        </div>
      </v-alert>
      
      <InsightsOverview ref="insightsOverview" />

    </v-card>
  </div>      
</template>

<script>
import { mapGetters } from "vuex";
import orgManagerService from "@/services/orgManagerService";
import { EventBus } from '@/plugins/eventbus.js';
import { DateTime } from 'luxon'
import siteData from '@/data/site.json'
import OrgUtil from "@/util/orgUtil";
import InsightsSummary from '@/components/eventmanager/InsightsSummary.vue';
import InsightsOverview from '@/components/eventmanager/InsightsOverview.vue';

export default {
  name: "Insights",
  components: {
    InsightsSummary,
    InsightsOverview,
  },
  props: {
    org: Object,
  },
  data() {
    return {
      siteData: siteData,
    };
  },
  async mounted() {
    await this.getProfile();
    
    EventBus.$on('login-state-change', async user => {
      await this.getProfile();
    });
  },
  methods: {
    async getEvent(id) {
      await this.getInsights();
    },
    async getInsights(date) {
      if (this.org) {
        this.$refs.insights.loadForOrg(this.org);
        this.$refs.insightsOverview.loadForOrg(this.org);
      }
    },
    async getProfile() {
      if (this.user) {
        await this.getEvent(this.$route.params.id);
      }
    },
    

  },
  computed: {
    breadcrumbItems() {
      return !this.org ? [] : [
        { text: 'Event Manager', exact: true, to: { name: 'eventmanager' } },
        { text: this.org.name, exact: true, to: { name: 'orgmanagerView', params: {id: this.org.id}} },
        { text: `Insights`, disabled: true },
      ];
    },
    orgUtil() {
      return new OrgUtil(this, this.org);
    },

    ...mapGetters({
      user: "user"
    })
  },
  watch: {
    async org(value) {
      await this.$nextTick();
      await this.getInsights();
    }
  }
};
</script>
<style lang="scss">
</style>

